import React from 'react';
import { Text, View } from 'react-native';
import { colors, spacing, type, useAppTheme } from '@/theme';
import { ScaledSheet } from '@/theme/responsive';

/** ৳1,350 for whole taka, ৳467.50 when there are paisa (a coupon can leave half a taka; it used to
 *  print as ৳467.5). Accepts the API's decimal strings too. */
export function formatTaka(amount: number | string) {
  const n = Number(amount) || 0;
  const paisa = Math.round(n * 100) % 100 !== 0;
  return `৳${n.toLocaleString('en-US', { minimumFractionDigits: paisa ? 2 : 0, maximumFractionDigits: 2 })}`;
}

interface Props {
  price: number;
  originalPrice?: number;
  size?: 'sm' | 'md' | 'lg';
  suffix?: string;
}

export function PriceTag({ price, originalPrice, size = 'md', suffix }: Props) {
  const { colors } = useAppTheme();
  const style = size === 'lg' ? type.h3 : size === 'md' ? type.titleLg : type.title;
  return (
    <View style={styles.row}>
      <Text style={[style, { color: colors.textPrimary }]}>{formatTaka(price)}</Text>
      {originalPrice && originalPrice > price && (
        <Text style={[type.bodySm, styles.strike, { color: colors.textTertiary }]}>{formatTaka(originalPrice)}</Text>
      )}
      {suffix && <Text style={[type.bodySm, { color: colors.textTertiary, flexShrink: 1 }]}>{suffix}</Text>}
    </View>
  );
}

const styles = ScaledSheet.create({
  row: { flexDirection: 'row', alignItems: 'baseline', gap: spacing.xs },
  strike: { color: colors.textTertiary, textDecorationLine: 'line-through' },
});
